module.exports = __webpack_public_path__ + "static/cdphe-7dcdb389b8d66a386bb1aff5d1c562ff.png";